import { render, staticRenderFns } from "./NOPOLTruck.vue?vue&type=template&id=1efabbc8&scoped=true&"
import script from "./NOPOLTruck.vue?vue&type=script&lang=js&"
export * from "./NOPOLTruck.vue?vue&type=script&lang=js&"
import style0 from "./NOPOLTruck.vue?vue&type=style&index=0&id=1efabbc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efabbc8",
  null
  
)

export default component.exports